<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: [
    'vmInstance'
  ],

  computed: {
    isOnStatus: function () {
      return this.vmInstance.infrastructure_instance &&
        this.vmInstance.infrastructure_instance.attributes.instance_status == 3
    },

    isOffStatus: function () {
      return this.vmInstance.infrastructure_instance &&
        this.vmInstance.infrastructure_instance.attributes.instance_status == 4
    },

    isProvisioningStatus: function () {
      return this.vmInstance.infrastructure_instance &&
        this.vmInstance.infrastructure_instance.attributes.instance_status == 2
    },

    isErrorStatus: function () {
      return this.vmInstance.infrastructure_instance &&
        this.vmInstance.infrastructure_instance.attributes.instance_status == 9
    },

    isHostTier: function () {
      return this.vmInstance.image_blueprint &&
        (
          this.vmInstance.image_blueprint.attributes.image_tier_id == 3 ||
          this.vmInstance.image_blueprint.attributes.image_tier_id == 7
        )
    },

    isWanTier: function () {
      return this.vmInstance.image_blueprint &&
        this.vmInstance.image_blueprint.attributes.image_tier_id == 4
    },

    isDualPathTopology: function () {
      return this.vmInstance.topology_blueprint &&
        this.vmInstance.topology_blueprint.attributes.blueprint_wan_path_count == 2
    },

    hasDiagramPosition: function () {
      return this.vmInstance.image_flavor &&
        this.vmInstance.image_flavor.attributes.flavor_diagram_top &&
        this.vmInstance.image_flavor.attributes.flavor_diagram_left
    },

    diagramStyle: function () {
      if(this.isHostTier) {
        return;
      }

      let width = 130
      let leftPosition = this.vmInstance.image_flavor.attributes.flavor_diagram_left

      if(this.isWanTier && this.isDualPathTopology) {
        leftPosition = 180
      }

      if(leftPosition == 180 || leftPosition == -90) {
        width = 110
      }

      return 'position: absolute; z-index: 1; width: ' + width + 'px; ' +
        'top: ' + this.vmInstance.image_flavor.attributes.flavor_diagram_top + 'px; ' +
        'left: ' + leftPosition + 'px;'
    }
  }
}
</script>

<template>
  <div class="topology-host"
    v-if="isHostTier || hasDiagramPosition"
    :style="diagramStyle"
  >
    <div class="topology-host-name">
      <div class="status"
        v-if="vmInstance.infrastructure_instance"
        :class="{ 'provisioning': isProvisioningStatus, 'on': isOnStatus, 'off': isOffStatus, 'error': isErrorStatus }"
      ><div class="circle"></div></div>
      <div class="status riverbed" v-else><div class="circle"></div></div>
      <div class="vm-name" v-if="vmInstance.image_blueprint">
        {{ vmInstance.image_blueprint.attributes.blueprint_name.split(' ')[0] }}
      </div>
    </div>
    <div class="topology-host-ips" v-if="vmInstance.image_flavor">
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic1_label && vmInstance.image_flavor.attributes.flavor_nic1_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic1_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic1_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic1_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic2_label && vmInstance.image_flavor.attributes.flavor_nic2_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic2_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic2_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic2_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic3_label && vmInstance.image_flavor.attributes.flavor_nic3_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic3_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic3_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic3_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic4_label && vmInstance.image_flavor.attributes.flavor_nic4_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic4_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic4_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic4_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic5_label && vmInstance.image_flavor.attributes.flavor_nic5_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic5_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic5_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic5_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic6_label && vmInstance.image_flavor.attributes.flavor_nic6_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic6_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic6_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic6_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic7_label && vmInstance.image_flavor.attributes.flavor_nic7_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic7_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic7_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic7_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic8_label && vmInstance.image_flavor.attributes.flavor_nic8_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic8_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic8_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic8_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic9_label && vmInstance.image_flavor.attributes.flavor_nic9_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic9_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic9_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic9_label }}
        </span>
      </div>
      <div class="topology-host-ip"
        v-if="vmInstance.image_flavor.attributes.flavor_nic10_label && vmInstance.image_flavor.attributes.flavor_nic10_ip_address"
        :title="vmInstance.image_flavor.attributes.flavor_nic10_label"
      >
        <code class="pull-right">{{ vmInstance.image_flavor.attributes.flavor_nic10_ip_address }}</code>
        <span class="topology-host-ip-label">
          {{ vmInstance.image_flavor.attributes.flavor_nic10_label }}
        </span>
      </div>
    </div>
    <div class="topology-host-ips" v-if="! vmInstance.image_flavor && vmInstance.image_blueprint">
      <div class="topology-host-ip"
        title="NO PUBLISHED FLAVORS"
      >
        <span class="topology-host-ip-label">
          NO PUBLISHED FLAVORS
        </span>
      </div>
    </div>
  </div>
</template>
